import React from 'react'
import { Button } from 'react-bootstrap'
import { Pencil } from 'react-bootstrap-icons'
import useClientLocation from '../../../hooks/use-client-location'

const LearningResourceEditButton = ({
    resource = {}
}) => {

    const { endpoints, toEndpoint } = useClientLocation()

    return (
        <Button
            variant='link'
            title='Delete'
            onClick={() => toEndpoint(endpoints.LEARNING_RESOURCE, { resourceId: resource.id })}
        >
            <Pencil />
        </Button>
    )

}

export default LearningResourceEditButton